import React from 'react'

/**
 * Debug UI container. View-as and other admin debug controls live in Account Settings.
 */
const Debugger = () => null

export default Debugger
